import StyledLink from '../StyledLink'
import {
  DUPLICATE,
  SYSTEM,
  WEBHOOK
} from '../routes'
import type { Props } from '../types'

interface Params {
  webhookUuid: string
}

const LinkToDuplicateWebhook = ({
  children,
  webhookUuid,
  openInNewTab,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    openInNewTab={openInNewTab}
    to={'/' + SYSTEM + '/' + WEBHOOK + '/' + webhookUuid + '/' + DUPLICATE}
  >
    {children}
  </StyledLink>

export default LinkToDuplicateWebhook
